import React, { useState, useEffect, useCallback } from 'react';
import { ILS, isoToday, isoYesterday } from '../../utils/salesUtils';

const METHODS = [
  { id: 'Cash',     ic: '💵', cls: 'cash'     },
  { id: 'Card',     ic: '💳', cls: 'card'     },
  { id: 'Bit',      ic: '📱', cls: 'bit'      },
  { id: 'Transfer', ic: '🏦', cls: 'transfer' },
];

const KEYS = ['1','2','3','4','5','6','7','8','9','.','0','⌫'];

export default function PaymentSheet({ remaining, onClose, onSave }) {
  const initial = String(Math.max(0, remaining || 0));
  const [amt, setAmt] = useState(initial === '0' ? '' : initial);
  const [method, setMethod] = useState('Cash');
  const [when, setWhen] = useState('today');

  const handleKey = useCallback((e) => {
    if (e.key === 'Escape') onClose();
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [handleKey]);

  const push = (k) => {
    setAmt(a => {
      if (k === '⌫') return a.length <= 1 ? '' : a.slice(0, -1);
      if (k === '.') return a.includes('.') ? a : (a || '0') + '.';
      if (a === '0') return String(k);
      if (a === '') return String(k);
      return a + k;
    });
  };

  const numericAmt = parseFloat(amt) || 0;

  const quickChips = [
    { label: 'Total', value: remaining },
    remaining > 1 ? { label: 'Mitad', value: Math.round(remaining / 2) } : null,
    { label: '$100', value: 100 },
    { label: '$200', value: 200 },
  ].filter(Boolean).filter(c => c.value > 0);

  const whenIso = when === 'today' ? isoToday() : when === 'yesterday' ? isoYesterday() : isoToday();
  const whenLabel = when === 'today' ? 'Hoy' : when === 'yesterday' ? 'Ayer' : 'Personalizado';

  const handleSave = () => {
    if (numericAmt <= 0) return;
    onSave({ method, amount: numericAmt, when: whenIso, whenLabel });
  };

  return (
    <div className="pos-backdrop" onClick={onClose}>
      <div className="pos-sheet" onClick={e => e.stopPropagation()}>
        <div className="pos-sheet-grabber" />
        <div className="pos-sheet-head">
          <h3>Registrar pago</h3>
          <button className="pos-sheet-close" onClick={onClose}>✕</button>
        </div>

        {/* Amount display — flex-shrink:0 per CSS gotcha */}
        <div className="pos-amount-display">
          <span className="pos-amount-cur">$</span>
          {amt || '0'}
        </div>

        {/* Quick chips — flex-shrink:0 */}
        <div className="pos-quick-chips">
          {quickChips.map((c, i) => (
            <button
              key={i}
              className={`pos-chip${numericAmt === c.value ? ' active' : ''}`}
              onClick={() => setAmt(String(c.value))}
            >
              {c.label}
            </button>
          ))}
        </div>

        {/* Keypad — flex-shrink:0 */}
        <div className="pos-keypad">
          {KEYS.map(k => (
            <button key={k} className="pos-key" onClick={() => push(k)}>{k}</button>
          ))}
        </div>

        {/* Method */}
        <div className="pos-sheet-section-label">Método</div>
        <div className="pos-method-grid">
          {METHODS.map(m => (
            <button
              key={m.id}
              className={`pos-method-btn${method === m.id ? ' active' : ''}`}
              onClick={() => setMethod(m.id)}
            >
              <span className="pos-method-ic">{m.ic}</span>
              {m.id}
            </button>
          ))}
        </div>

        {/* Date */}
        <div className="pos-sheet-section-label">Fecha</div>
        <div className="pos-date-chips">
          {[['today','Hoy'],['yesterday','Ayer'],['custom','Personalizado']].map(([v,l]) => (
            <button
              key={v}
              className={`pos-chip${when === v ? ' active' : ''}`}
              onClick={() => setWhen(v)}
            >
              {l}
            </button>
          ))}
        </div>

        <div className="pos-sheet-pad">
          <button className="pos-confirm-btn" onClick={handleSave} disabled={numericAmt <= 0}>
            Guardar pago{numericAmt > 0 ? ` · ${ILS(numericAmt)}` : ''}
          </button>
        </div>
      </div>
    </div>
  );
}
